import { render, staticRenderFns } from "./ComplaintsFilterSolip.vue?vue&type=template&id=66af958e"
import script from "./ComplaintsFilterSolip.vue?vue&type=script&lang=js"
export * from "./ComplaintsFilterSolip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports